import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import { Helmet } from 'react-helmet'
import { Btn, LoaderPage } from '../components'
import { BrandFormSchema } from '../utils'
import { useYupValidation } from '../hooks'
import { IBrandForm } from '../interfaces'
import questions from '../utils/questions.json'

export interface IQuestion {
	_id: string
	name: string
	questions: [
		{
			_id: string
			question: string
		}
	]
}

export default function BrandForm(): React.ReactElement {
	const navigate = useNavigate()

	function root(): void {
		window.location.reload()
	}
	useEffect(() => {
		const header = document.querySelector('.menu')
		if (header) {
			header.classList.remove('header--margin-left', 'header--centralize')
		}
	})
	const {
		control,
		formState: { errors },
		handleSubmit,
	} = useForm<IBrandForm>({
		resolver: useYupValidation(BrandFormSchema),
	})

	const [isLoading, setIsLoading] = useState(false) // CONTROLA O CARREGAMENTO
	const [isError, setIsError] = useState(false) // CONTROLE DE ERRO DA PAGINA
	// const [value setValue] = useState("")
	const [arrQuest, setArrQuestion] = useState<IQuestion[]>([]) // CONTROLA O ESTADO DA LEITURA DA API
	async function getStepsQuestions(): Promise<void> {
		setIsError(false)
		try {
			setIsLoading(true)
			const json = questions as Array<IQuestion>
			setIsLoading(false)
			setArrQuestion(json)
		} catch (e) {
			setIsError(true)
		}
	}

	useEffect(() => {
		getStepsQuestions()
	}, [])

	async function submit(valuesSchema: IBrandForm): Promise<void> {
		try {
			// Transformar o objeto em string e salvar em localStorage
			localStorage.setItem('userValues', JSON.stringify(valuesSchema))
			localStorage.removeItem('userAnswers')
			localStorage.removeItem('lastResponseId')
			localStorage.removeItem('brandTechChatId')
			localStorage.removeItem('chatHistory')

			navigate('/introducao')
		} catch (e) {
			setIsError(true)
		}
	}

	function applyPhoneMaskHandler(event: React.ChangeEvent<HTMLInputElement>, onChange: Function): void {
		let newValue = event.target.value

		if (!newValue) {
			onChange('')
			return
		}

		newValue = newValue.replace(/\D/g, '').slice(0, 11)

		if (newValue.length >= 2) {
			newValue = newValue.replace(/(\d{2})(\d)/, '($1) $2')
		}

		if (newValue.length >= 7) {
			newValue = newValue.replace(/(\d)(\d{4})$/, '$1-$2')
		}

		event.target.value = newValue
		onChange(event)
	}

	return (
		<div className="container brand-form">
			<Helmet>
				<title> Descubra sua pontuação em Brand Scoring </title>
				<meta
					name="description"
					content="Descubra sua pontuação
					em Brand Scoring"
				/>
			</Helmet>
			{isError ? (
				<LoaderPage
					error={isError}
					retry={() => {
						root()
					}}
				/>
			) : (
				<>
					<div className="content">
						<h1>
							Descubra sua pontuação <br /> em Brand Scoring powered <br /> by GH Brandtech em 9 minutos.
						</h1>

						<p className="first-txt">
							{arrQuest.length > 0 &&
								arrQuest.reduce(
									(previus, steps) => previus + steps.questions.length,

									0
								)}{' '}
							perguntas em {arrQuest.length}
							{arrQuest.length >= 2 ? ' áreas' : ' área'} da
							<> Brandtech que combinam </>
							{arrQuest.map((item, i) =>
								i + 1 === arrQuest.length ? `${item.name}.` : i + 1 === arrQuest.length - 1 ? `${item.name} e ` : `${item.name}, `
							)}
						</p>

						<div className="content-second">
							<p>Você também receberá um relatório de plano de ação personalizado com dicas e sugestões</p>

							<img
								src="/assets/img/outhers/laptop-brandtech.png"
								alt="Brand Scoring"
								title="Brand Scoring"
								className="brandtech-desktop"
							/>
						</div>

						<p className="start-desktop">Vamos começar.</p>
					</div>

					<form onSubmit={handleSubmit(submit)}>
						<div className="form_item">
							<span className="label"> Nome </span>
							<Controller
								control={control}
								name="leadName"
								render={({ field: { onChange, value } }) => (
									<input
										type="text"
										placeholder="Seu nome"
										onChange={onChange}
										value={value || ''}
										className="input"
										autoComplete="off"
									/>
								)}
							/>
							<div className="error">
								{errors.leadName && <span className="input-error w-full text-left">{errors.leadName.message}</span>}
							</div>
						</div>

						<div className="form_item">
							<span className="label"> E-mail </span>
							<Controller
								control={control}
								name="leadEmail"
								render={({ field: { onChange, value } }) => (
									<input
										type="email"
										placeholder="Seu E-mail"
										autoComplete="off"
										className="input"
										onChange={onChange}
										value={value || ''}
									/>
								)}
							/>
							<div className="error">
								{errors.leadEmail && <span className="input-error w-full text-left">{errors.leadEmail.message}</span>}
							</div>
						</div>

						<div className="form_item">
							<span className="label">Whatsapp</span>
							<Controller
								control={control}
								name="leadPhoneWhats"
								render={({ field: { onChange, value } }) => (
									<input
										type="tel"
										placeholder="(99) 99999-9999"
										onChange={evt => applyPhoneMaskHandler(evt, onChange)}
										value={value || ''}
										className="input"
										autoComplete="off"
									/>
								)}
							/>
							<div className="error">
								{errors.leadPhoneWhats && <span className="input-error w-full text-left">{errors.leadPhoneWhats.message}</span>}
							</div>
						</div>

						<div className="form_item">
							<span className="label">Qual sua empresa?</span>
							<Controller
								control={control}
								name="leadBusinessName"
								render={({ field: { onChange, value } }) => (
									<input
										type="text"
										placeholder="Sua empresa"
										onChange={onChange}
										value={value || ''}
										className="input"
										autoComplete="off"
									/>
								)}
							/>
							<div className="error">
								{errors.leadBusinessName && <span className="input-error w-full text-left">{errors.leadBusinessName.message}</span>}
							</div>
						</div>

						<div className="form_item">
							<span className="label">Qual site da sua empresa?</span>
							<Controller
								control={control}
								name="leadBusinessWebsite"
								render={({ field: { onChange, value } }) => (
									<input
										type="text"
										placeholder="ghbranding.com.br"
										onChange={onChange}
										value={value || ''}
										className="input"
										autoComplete="off"
									/>
								)}
							/>
							<div className="error">
								{errors.leadBusinessWebsite && (
									<span className="input-error w-full text-left">{errors.leadBusinessWebsite.message}</span>
								)}
							</div>
						</div>

						<div className="form_item">
							<span className="label">Qual o tamanho da sua empresa?</span>

							<Controller
								control={control}
								name="leadBusinessSize"
								render={({ field: { onChange, value } }) => (
									<select required placeholder="selecione o seu tamanho" onChange={onChange} value={value} className="input">
										<option hidden> Selecione </option>
										<option value="1-50"> 1-50 </option>
										<option value="51-100"> 51-100 </option>
										<option value="101-500"> 101-500 </option>
										<option value="501-1000"> 501-1000 </option>
										<option value="Mais de 1000">Mais de 1000</option>
									</select>
								)}
							/>
							<div className="error">
								{errors.leadBusinessSize && <span className="input-error w-full text-left">{errors.leadBusinessSize.message}</span>}
							</div>
						</div>
						<div className="form_item">
							<Controller
								control={control}
								name="privacidade"
								render={({ field: { onChange } }) => (
									<div className="check pt-2">
										<input type="checkbox" onChange={onChange} required />

										<a
											href="https://ghbranding.com.br/politica-de-privacidade/"
											target="_blank"
											rel="noreferrer"
											title="Política de privacidade"
										>
											<p> Política de privacidade</p>
										</a>
									</div>
								)}
							/>
							<div className="error-check">
								{errors.privacidade && <span className="input-error w-full text-left">{errors.privacidade.message}</span>}
							</div>
						</div>
						{isLoading ? (
							<LoaderPage pasDelay={isLoading} variant="loader-btn" />
						) : (
							<Btn variant="form-btn" height="2.313rem" width="7rem" placeholder="Começar" />
						)}
					</form>

					<div className="content-relatório-mobile">
						<p className="txt-relatorio">Você também receberá um relatório de plano de ação personalizado com dicas e sugestões</p>
						<p className="txt-start"> Vamos começar. </p>

						<div className="center">
							<img
								src="/assets/img/outhers/mobile brand scoring-mobile.png"
								alt="Brand Scoring"
								title="Brand Scoring"
								className="brandtech-mobile"
							/>{' '}
						</div>
					</div>
				</>
			)}
		</div>
	)
}
